module.exports = __webpack_public_path__ + "img/alka_seltzer_plus_maximum_strength.e0a7f6b8.png";